import React, { useState } from "react";
import moment from "moment-timezone";
import { useDispatch, useSelector } from "react-redux";
import { fetchUserInfo, selectAuthState } from "@/stores/slices/authSlice";
import { Modal } from "antd";
import { activeUserProfile, sendOTPVerifyEmail, sendOTPVerifyPhone } from "@/stores/apis/apiAuth";
import { toast } from "@/modules/toast";
import { NOTIFICATION_TYPE, OTP_TIMEOUT } from "@/config/constants";
import { IconCloseSvg } from "@/components/svgs";
import ConfirmOTP from "./ConfirmOTP";
import SendOTP from "./SendOTP";
import styled from "styled-components";
import { noop } from "lodash";

export const ModalActiveAccount = ({ visible = false, onClose, onActiveSuccess = noop }) => {
	const dispatch = useDispatch();
	const { user } = useSelector(selectAuthState);

	const [loading, setLoading] = useState(false);
	const [step, setStep] = useState("SEND_OTP"); // SEND_OTP - VERIFICATION_OTP
	const [expiredDate, setExpiredDate] = useState("");
	const [method, setMethod] = useState({});

	const nextStep = (route) => {
		setStep(route);
	};

	const onSubmitConfirmOTP = async (otp) => {
		const data = {
			code: otp,
			method: method === "phone" ? "sms" : "email",
			email: user?.email,
		};
		const rs = await activeUserProfile(data);
		if (rs && rs.success) {
			await dispatch(fetchUserInfo());
			onActiveSuccess?.();
			setStep("SEND_OTP");
			onClose();
		} else {
			toast({
				type: NOTIFICATION_TYPE.ERROR,
				description: "OTP Verification Failed.",
			});
		}
	};

	const onSendOTP = async (type) => {
		if (loading) return;

		setLoading(true);

		const payload = {
			email: user?.email,
			phone: user?.phone,
		};
		let result;
		if (type === "email") {
			result = await sendOTPVerifyEmail(payload);
		} else {
			result = await sendOTPVerifyPhone(payload);
		}
		if (result && result.success) {
			setExpiredDate(moment().add(OTP_TIMEOUT, "minutes").toString());
			setMethod(type);
			nextStep("VERIFICATION_OTP");
		} else {
			toast({
				type: NOTIFICATION_TYPE.ERROR,
				description: result?.error?.message || "Send OTP Failed.",
			});
		}

		setTimeout(() => {
			setLoading(false);
		}, 300);
	};

	const onSendOTPAgain = async () => {
		if (loading) return;
		setLoading(true);

		const payload = {
			email: user?.email,
			phone: user?.phone,
		};
		let result;
		if (method === "email") {
			result = await sendOTPVerifyEmail(payload);
		} else {
			result = await sendOTPVerifyPhone(payload);
		}
		if (result && result.success) {
			setExpiredDate(moment().add(OTP_TIMEOUT, "minutes").toString());
			toast({
				type: NOTIFICATION_TYPE.SUCCESS,
				description: "OTP Sent Successfully!",
			});
		} else {
			toast({
				type: NOTIFICATION_TYPE.ERROR,
				description: "Send OTP Failed.",
			});
		}

		setTimeout(() => {
			setLoading(false);
		}, 300);
	};

	const _renderRegiterWithProcess = () => {
		switch (step) {
			case "SEND_OTP":
				return <SendOTP userInfo={user} onSendOTP={onSendOTP} loading={loading} />;
			case "VERIFICATION_OTP":
				return (
					<ConfirmOTP
						loading={loading}
						userInfo={user}
						method={method}
						expiredDate={expiredDate}
						onSendOTPAgain={onSendOTPAgain}
						onSubmitConfirmOTP={onSubmitConfirmOTP}
					/>
				);

			default:
				return null;
		}
	};

	return (
		<Modal
			centered
			closeIcon={<IconCloseSvg />}
			open={visible}
			onCancel={() => {
				setStep("SEND_OTP");
				onClose(false);
			}}
			footer={null}
			width="auto"
			wrapClassName="auth-wrapper"
			style={{ padding: 0, margin: "20px 0px" }}
		>
			<Container>{_renderRegiterWithProcess()}</Container>
		</Modal>
	);
};

const Container = styled.div`
	padding-top: 30px;
	padding-bottom: 30px;
	width: 50vw;
	max-width: 620px;
	min-width: 343px;
	padding: clamp(24px, 8vw, 60px) clamp(16px, 4vw, 60px);
`;
